export const pagePolicy = {
    // ロード完了したとき
    loadDone: function (results) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        // 保存ボタンが押されたときの挙動。
        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            form.disableButtons(this);

            $(".nursery__side-menu-content").data("editing", "false");
            window.removeEventListener("beforeunload", nursery.saveAlert);
            const url = $("#basicForm").attr("action");
            form.post(url, "#basicForm", "更新が完了しました", () => {
                pagePolicy.postDone();
                form.activateButtons(this);
            });
        });

        // 保育施設の職員情報のときはイメージプレビュー起動
        imagePreview.preview(".principal-pict__container-text", ".principal-pict__pict");

        // 削除ボタンの定義
        $(".js-image-delete").unbind("click");
        $(".js-image-delete").click(function () {
            imagePreview.deleteImage(".principal-pict__pict");
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });

        // 画像の変更があった時、離脱時にアラートを表示
        $(".js-upload-file").change(function () {
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });

        // フォームに変更があった時、離脱時にアラートを表示
        $("form").change(function () {
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });
    },
    // POST完了
    postDone: function (results) {
        $("#js-nav-pagetop").trigger("click");
    }
};
